import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Label, Row, Col } from 'reactstrap';
import Password from '../../../Basic/Password';
import { validatePassword } from '../../utils/formValidation';
import { changePassword } from '../../api';
import { withSection } from '../withSection';
var errorMessagePassword = {
  noError: '',
  notMatch: 'SFxUserPreferencesRestPwNoMatch',
  incorrect: 'SFxUserPreferencesRestPwIncorrect',
  notNew: 'SFxUserPreferencesRestPwNotNew',
  error: 'SFxUserPreferencesRestPwError'
};
export var PasswordReset = withSection(function (props) {
  var defaultPasswordValues = {
    currentPassword: '',
    password: '',
    verifyPassword: ''
  };
  var prefix = props.prefix,
      userPreferencesCallback = props.userPreferencesCallback,
      trans = props.trans;

  var _useState = useState(defaultPasswordValues),
      _useState2 = _slicedToArray(_useState, 2),
      passwordValues = _useState2[0],
      setPasswordValues = _useState2[1];

  var _useState3 = useState('noError'),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessageType = _useState4[0],
      setErrorMessageType = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      canSubmit = _useState6[0],
      setCanSubmit = _useState6[1];

  var onPswChange = function onPswChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    setPasswordValues(_objectSpread(_objectSpread({}, passwordValues), _defineProperty({}, name, value)));
  };

  useEffect(function () {
    var currentPassword = passwordValues.currentPassword,
        password = passwordValues.password,
        verifyPassword = passwordValues.verifyPassword;
    var canSubmit = currentPassword && currentPassword.trim() && password && password.trim() && verifyPassword && verifyPassword.trim() && errorMessageType === 'noError';
    setCanSubmit(!!canSubmit);
  }, [errorMessageType, passwordValues]);
  useEffect(function () {
    var currentPassword = passwordValues.currentPassword,
        password = passwordValues.password,
        verifyPassword = passwordValues.verifyPassword;

    var confirmPassword = function confirmPassword() {
      var errorMessageType = 'noError';

      if (passwordValues.password) {
        var validResult = validatePassword(passwordValues.password);
        errorMessageType = validResult.valid ? 'noError' : 'error';
      }

      if (errorMessageType === 'noError' && currentPassword && password) {
        errorMessageType = currentPassword.trim() === password.trim() ? 'notNew' : 'noError';
      }

      if (errorMessageType === 'noError' && password && verifyPassword) {
        errorMessageType = password.trim() === verifyPassword.trim() ? 'noError' : 'notMatch';
      }

      setErrorMessageType(errorMessageType);
    };

    confirmPassword();
  }, [passwordValues]);

  var onSubmitPsw = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var currentPassword, password, verifyPassword, param;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCanSubmit(false);
              currentPassword = passwordValues.currentPassword, password = passwordValues.password, verifyPassword = passwordValues.verifyPassword;
              param = {
                ModificationTime: new Date().toLocaleString(),
                ConfirmPassword: verifyPassword,
                NewPassword: password,
                OldPassword: currentPassword
              };
              _context.prev = 3;
              _context.next = 6;
              return changePassword(param, {
                catchError: true
              });

            case 6:
              userPreferencesCallback({
                changePassword: true
              });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              setErrorMessageType('incorrect');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function onSubmitPsw() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
    form: true
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "company"
  }, trans('SFxUserPreferencesCurrentPwLabel')), /*#__PURE__*/React.createElement(Password, {
    fieldName: "currentPassword",
    className: "".concat(prefix, "-password"),
    placeHolder: " ",
    defaultValue: passwordValues.currentPassword,
    onChange: onPswChange
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "company"
  }, trans('SFxUserPreferencesNewPwLabel')), /*#__PURE__*/React.createElement(Password, {
    fieldName: "password",
    className: "".concat(prefix, "-password"),
    defaultValue: passwordValues.password,
    placeHolder: " ",
    onChange: onPswChange
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "company"
  }, trans('SFxUserPreferencesVerifyPwLabel')), /*#__PURE__*/React.createElement(Password, {
    fieldName: "verifyPassword",
    className: "".concat(prefix, "-password"),
    defaultValue: passwordValues.verifyPassword,
    placeHolder: " ",
    onChange: onPswChange
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-formValidErrorTip")
  }, trans(errorMessagePassword[errorMessageType])))), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "primary",
    disabled: !canSubmit,
    onClick: onSubmitPsw
  }, trans('SFxUserPreferencesChangePw')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-href"),
    onClick: function onClick() {
      return userPreferencesCallback({
        forgotPassword: true
      });
    },
    style: {
      display: 'inline-block',
      marginLeft: '10px',
      cursor: 'pointer'
    }
  }, trans('SFxUserPreferencesForgotPw')));
});